import React, { useState } from 'react';
import './contact.css';
import { db, collection, addDoc } from '../LoginComp/firebase';
import emailjs from 'emailjs-com'; 

function ContactUs() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      // Save data to Firebase Firestore
      const contactsCollectionRef = collection(db, 'contactus');
      await addDoc(contactsCollectionRef, {
        name: formData.name,
        email: formData.email,
        message: formData.message,
        timestamp: new Date(),
      });
      

      // Send email via EmailJS
      const emailParams = {
        name: formData.name,
        email: formData.email,
        message: formData.message,
      };

      await emailjs.send(
        'service_81uz1wl', 
        'template_f9sy9b2', 
        emailParams,
        '1FnnU1tQke8OBsbR_' 
      );
      alert('Your message has been sent!');

    // Reset form data after upload
    setFormData({
      name: '',
      email: '',
      message: '',
    });


    } catch (error) {
      console.error('Error saving or sending message:', error);
      alert('Error saving or sending your message. Please try again later.');
    }
  };

  return (
    <div className="contact-us-container">
      <section className="contact-header">
        <h1>Contact Us</h1>
        <p>We'd love to hear from you. Please reach out with any questions!</p>
      </section>

      <section className="contact-form-section-contactus">
        <form onSubmit={handleSubmit} className="contact-form-contactus">
          <div className="form-group-contactus">
            <label htmlFor="name">Name</label>
            <input
              type="text"
              id="name"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group-contactus">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group-contactus">
            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              name="message"
              placeholder="Your Message"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
          </div>
          <button type="submit" className="submit-btn-contactus">Submit</button>
        </form>
      </section>

      <section className="google-map-section">
        <h3>Our Location</h3>
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3960.7513034374824!2d79.86938077448275!3d6.920306318426057!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae259744a1d7131%3A0x614fbd9988cf7417!2sEye%20Care%20Institute!5e0!3m2!1sen!2slk!4v1737795789046!5m2!1sen!2slk" 
        width="700" 
        height="450" 
        style={{ border: 0 }} 
        allowfullscreen="" 
        loading="lazy" 
        referrerpolicy="no-referrer-when-downgrade">
        </iframe>
      </section>

      <section className="business-hours-section">
        <h3>Business Hours</h3>
        <ul>
          <li>Monday - Saturday: 9:00 AM - 6:00 PM</li>
          <li>Sunday: Closed</li>
        </ul>
      </section>
    </div>
  );
}

export default ContactUs;


     
